
import React, { useEffect, useState } from 'react';
import { db, Storage} from '../firebase';
import { collection, getDocs, query, where, doc, setDoc, addDoc} from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL, listAll, uploadBytes  } from 'firebase/storage';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ToWords } from 'to-words';

const toWords = new ToWords({
  localeCode: 'en-IN',
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
  }
});

const BrandMonthlyInvoice = () => {
    const [invoices, setInvoices] = useState([]);
    const [filteredInvoices, setFilteredInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [brands, setBrands] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState('All');
    const [selectedBrandInfo, setSelectedBrandInfo] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [generating, setGenerating] = useState(false);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalItemsPrice, setTotalItemsPrice] = useState(0);
    const [totalShippingPrice, setTotalShippingPrice] = useState(0);
    const [totalPackagingPrice, setTotalPackagingPrice] = useState(0);
    const [totalBrandingPrice, setTotalBrandingPrice] = useState(0);
    const [dataLoaded, setDataLoaded] = useState(false);
const [loadingData, setLoadingData] = useState(false);
const [progress, setProgress] = useState(0);
const [progressLabel, setProgressLabel] = useState('');

   
   
    const fetchInvoices = async () => {

         if (!fromDate || !toDate) {
        alert('Please select both From Date and To Date before loading data.');
        return;
    }
      setLoading(true);
setLoadingData(true);
setDataLoaded(false);
        try {
            const usersSnapshot = await getDocs(collection(db, 'users'));
            const allInvoices = [];
            const brandSet = new Set();
            const brandInfoMap = new Map();

            const excludedUserIds = ['CrQeQiv7iDPcP4HDzpsaeiNscDJ3', '6kIL0hVdsmUee3zCDr2XGzrTjyY2', 'Ge9xCYPWAqcixxj6wzfpHd1XWPF2', 'Kmqq21oSecfkqjpj34MsUkp1IxC2'];


            const totalUsers = usersSnapshot.docs.filter(d => !excludedUserIds.includes(d.id)).length;
let processedUsers = 0;
setProgress(0);
setProgressLabel('Fetching brand data...');
           
            for (const userDoc of usersSnapshot.docs) {
                const userData = userDoc.data();
                const brandName = userData.brandName || 'Unknown Brand';
                const userId = userDoc.id;
                const gstNumber = userData.gstNumber || '';
                const state = userData.state || '';
                const address = userData.address || '';
                const pincode = userData.pincode || '';

                if (excludedUserIds.includes(userId)) {
                 continue;
                }
                
                // Store brand info for later use
                brandInfoMap.set(userId, {
                    brandName,
                    gstNumber,
                    state,
                    address,
                    pincode,
                    userId
                });
                
            const ordersCollection = collection(db, 'users', userId, 'orders');
            const ordersQuery = query(ordersCollection, where('status', '==', "confirmed"));
            const ordersSnapshot = await getDocs(ordersQuery);

            const transactionsCollection = collection(db, 'users', userId, 'wallet', 'walletDetails', 'transactions');
            const transactionsSnapshot = await getDocs(transactionsCollection);


                ordersSnapshot.forEach(orderDoc => {
                    const orderData = orderDoc.data();

    let orderDate = 'N/A';
    if (orderData.updatedAt) {
        const date = orderData.updatedAt.toDate ? orderData.updatedAt.toDate() : orderData.updatedAt;
        
        // Extract date components in local timezone to avoid shifts
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        orderDate = `${year}-${month}-${day}`;
    }
                    
                 const orderId = orderDoc.id;
                     if (orderData.is_replacement === true || orderId.startsWith('REP')) {
                return;
                      }

                 
                        const invoiceUrl = orderData.invoiceUrl;
                    
                    // Calculate shipping charges
                    let totalShippingCharges = 0;
                    
                    // 1. Regular UniteeShipping
                    const uniteeShipping = parseFloat(orderData.UniteeShipping) || 0;
                    totalShippingCharges += uniteeShipping;
                    
                    // 3. Packaging charges for RTO items (50 per item with RTOinventory = true)
                    let packagingCharges = 0;
                    if (orderData.order_items && Array.isArray(orderData.order_items)) {
                        orderData.order_items.forEach(item => {
                            if (item.RTOinventory === true) {
                                packagingCharges += 55.46; // 18% tax included
                            }
                        });
                    }
                    
                    // Filter out items where RTOinventory is true and calculate totals
                    let totalOrderQuantity = 0;
                    let totalOrderItemsPrice = 0;
                    const validItems = [];
                    
                    if (orderData.order_items && Array.isArray(orderData.order_items)) {
                        orderData.order_items.forEach(item => {
                            // Skip items where RTOinventory is true
                            if (item.RTOinventory !== true) {
                                const quantity = parseInt(item.units) || 0;
                                const itemPrice = parseFloat(item.itemTotalPrice) || 0;
                                
                                totalOrderQuantity += quantity;
                                totalOrderItemsPrice += itemPrice;
                                validItems.push(item);
                            }
                        });
                    }


const brandingCharges = orderData.order_items?.reduce((sum, item) => {
    const units = parseInt(item.units) || 0;
    const brandingCostPerUnit = parseFloat(item.packagingCost) || 0;
    return sum + (brandingCostPerUnit * units);
}, 0) || 0;

                    allInvoices.push({
                        id: orderDoc.id,
                        userId: userId,
                        brandName: brandName,
                        gstNumber: gstNumber,
                        invoiceUrl: invoiceUrl,
                        orderDate: orderDate,
                        totalQuantity: totalOrderQuantity,
                        totalItemsPrice: totalOrderItemsPrice,
                        totalShippingCharges: totalShippingCharges,
                        totalPackagingCharges: packagingCharges,
                        totalBrandingCharges: brandingCharges,
                        order_items: validItems,
                        billing_customer_name: orderData.billing_customer_name,
                        billing_email: orderData.billing_email,
                        billing_phone: orderData.billing_phone,
                        billing_address: orderData.billing_address,
                        billing_city: orderData.billing_city,
                        billing_state: orderData.billing_state,
                        billing_pincode: orderData.billing_pincode,
                        billing_country: orderData.billing_country,
                        Storeorder_id: orderData.Storeorder_id,
                        payment_method: orderData.payment_method,
                        status: orderData.status,
                        tracking_id: orderData.tracking_id,
                        courier_name: orderData.courier_name,
                        completeOrderData: orderData
                    });

                    brandSet.add(brandName);
                });

                // Process return orders for additional shipping charges
           

                            transactionsSnapshot.forEach(transactionDoc => {
                const transactionData = transactionDoc.data();
                const transactionType = transactionData.type;
                const transactionAmount = parseFloat(transactionData.amount) || 0;
                // const transactionDate = transactionData.timestamp ? 
                //     new Date(transactionData.timestamp.toDate ? transactionData.timestamp.toDate() : transactionData.timestamp).toISOString().split('T')[0] : 'N/A';
                

                let transactionDate = 'N/A';
    if (transactionData.timestamp) {
        const date = transactionData.timestamp.toDate ? transactionData.timestamp.toDate() : transactionData.timestamp;
        
        // Extract date components in local timezone to avoid shifts
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        transactionDate = `${year}-${month}-${day}`;
    }
                if (transactionType && (transactionType.startsWith('Return_') || transactionType === 'RTO Initiated')) {
                    allInvoices.push({
                        id: `transaction_${transactionDoc.id}`,
                        userId: userId,
                        brandName: brandName,
                        gstNumber: gstNumber,
                        invoiceUrl: null,
                        orderDate: transactionDate,
                        totalQuantity: 0,
                        totalItemsPrice: 0,
                        totalShippingCharges: transactionAmount,
                        totalPackagingCharges: 0,
                        order_items: [],
                        isTransactionOrder: true,
                        transactionType: transactionType,
                        // billing_customer_name: transactionType.startsWith('Return_') ? 'Return Order' : 'RTO Order',
                        completeOrderData: transactionData
                    });
                }
            });

             brandSet.add(`${brandName}|${userId}`)
             processedUsers++;
setProgress(Math.round((processedUsers / totalUsers) * 100));
setProgressLabel(`Loading brands... (${processedUsers}/${totalUsers})`);
        }
        
            setInvoices(allInvoices);
            setFilteredInvoices(allInvoices);
        const uniqueBrandNames = new Set();
        brandInfoMap.forEach(info => uniqueBrandNames.add(info.brandName));
        setBrands(['All', ...Array.from(uniqueBrandNames)]);
            
            // Store the brand info map for later use when generating invoices
            window.brandInfoMap = brandInfoMap;
        } catch (error) {
            console.error("Error fetching invoices:", error);
    } finally {
    setLoading(false);
    setLoadingData(false);
    setDataLoaded(true);
    setProgress(100);
    setProgressLabel('Data loaded successfully!');
}
    };


useEffect(() => {
    let filtered = invoices;

    if (selectedBrand !== 'All') {
        filtered = filtered.filter(inv => inv.brandName === selectedBrand);
        
        // Get all brand infos with this brandName
        const matchingBrandInfos = Array.from(window.brandInfoMap?.values() || [])
            .filter(info => info.brandName === selectedBrand);
        
        if (matchingBrandInfos.length > 0) {
            setSelectedBrandInfo(matchingBrandInfos[0]); // Set first match for display
        }
    } else {
        setSelectedBrandInfo(null);
    }

    if (fromDate) {
        filtered = filtered.filter(inv => inv.orderDate >= fromDate);
    }

    if (toDate) {
        filtered = filtered.filter(inv => inv.orderDate <= toDate);
    }

    setFilteredInvoices(filtered);
    
    // Calculate totals
    const totalQty = filtered.reduce((sum, inv) => sum + inv.totalQuantity, 0);
    const totalItemsPriceSum = filtered.reduce((sum, inv) => sum + inv.totalItemsPrice, 0);
    const totalShippingSum = filtered.reduce((sum, inv) => sum + (inv.totalShippingCharges || 0), 0);
    const totalPackagingSum = filtered.reduce((sum, inv) => sum + (inv.totalPackagingCharges || 0), 0);
    const totalBrandingSum = filtered.reduce((sum, inv) => sum + (inv.totalBrandingCharges || 0), 0);

    
    setTotalQuantity(totalQty);
    setTotalItemsPrice(totalItemsPriceSum);
    setTotalShippingPrice(totalShippingSum);
    setTotalPackagingPrice(totalPackagingSum);
    setTotalBrandingPrice(totalBrandingSum);
    
}, [selectedBrand, fromDate, toDate, invoices]);
    
    const getFinancialYear = () => {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1; // JavaScript months are 0-indexed
        
        if (currentMonth >= 6) { // April onwards
            return `${currentYear}-${currentYear + 1}`;
        } else { // January to March
            return `${currentYear - 1}-${currentYear}`;
        }
    };



   const getNextInvoiceNumber = async (invoiceType) => {
    try {
        const folderPath = `invoices/${invoiceType}/`;
        const storageRef = ref(Storage, folderPath);

        console.log(`Getting next invoice number for type: ${invoiceType}`);

        const listResult = await listAll(storageRef);
        let nextInvoiceNumber = 1;

        if (listResult.items.length > 0) {
            const invoiceNumbers = [];

            listResult.items.forEach(item => {
                console.log(`Checking file: ${item.name}`);

                // Match filenames: UC_<invoiceType>_<year>_<yearNext>_<sequence>_<brand>.pdf
                const regex = new RegExp(`^UC_${invoiceType}_[0-9]{4}_[0-9]{4}_(\\d+)_.*\\.pdf$`);
                const match = item.name.match(regex);

                if (match) {
                    const number = parseInt(match[1], 10);
                    if (!isNaN(number)) invoiceNumbers.push(number);
                }
            });

            if (invoiceNumbers.length > 0) {
                nextInvoiceNumber = Math.max(...invoiceNumbers) + 1;
            }
        }

        // Return formatted invoice number for PDF (no year)
        return `UC/${invoiceType}/${nextInvoiceNumber.toString().padStart(2, '0')}`;
    } catch (error) {
        console.error(`Error getting next invoice number for ${invoiceType}:`, error);
        return `UC/${invoiceType}/01`;
    }
};
 


const uploadPDFToStorage = async (pdfBlob, invoiceType, invoiceNumber, brandName, userId) => {
    try {
        const parts = invoiceNumber.split('/');
        const sequence = parts[2];

        // Get all brandInfos with the same brandName
        const allBrandInfos = Array.from(window.brandInfoMap?.values() || []);
        const sameBrandNames = allBrandInfos.filter(info => info.brandName === brandName);
        
        // Find the index of current userId among brands with same name
        let brandNameSuffix = '';
        if (sameBrandNames.length > 1) {
            const sortedByUserId = sameBrandNames.sort((a, b) => a.userId.localeCompare(b.userId));
            const index = sortedByUserId.findIndex(info => info.userId === userId);
            brandNameSuffix = `_${String(index + 1).padStart(2, '0')}`; // Add 01, 02, etc.
        }

        const sanitizedBrandName = brandName.replace(/[^a-zA-Z0-9]/g, '_');
        
        // Calculate financial year correctly
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1; // 1-12
        
        let financialYearStart, financialYearEnd;
        if (currentMonth >= 6) {
            // April onwards: FY is current year to next year
            financialYearStart = currentYear;
            financialYearEnd = currentYear + 1;
        } else {
            // January to March: FY is previous year to current year
            financialYearStart = currentYear - 1;
            financialYearEnd = currentYear;
        }

        // Filename includes the suffix for duplicate brandNames
        const fileName = `UC_${invoiceType}_${financialYearStart}_${financialYearEnd}_${sequence}_${sanitizedBrandName}${brandNameSuffix}.pdf`;

        const storageRef = ref(Storage, `invoices/${invoiceType}/${fileName}`);
        const uploadTask = await uploadBytesResumable(storageRef, pdfBlob);
        const downloadURL = await getDownloadURL(uploadTask.ref);

        console.log(`File uploaded successfully: ${fileName}`);
        return downloadURL;
       
    } catch (error) {
        console.error(`Error uploading ${invoiceType} invoice:`, error);
        throw error;
    }
};


// Optional: Add a function to prevent race conditions when generating multiple invoices
const invoiceNumberLocks = new Map();

// const getNextInvoiceNumberWithLock = async (invoiceType) => {
//     // Simple lock mechanism to prevent race conditions
//     if (invoiceNumberLocks.has(invoiceType)) {
//         // Wait for the previous operation to complete
//         await invoiceNumberLocks.get(invoiceType);
//     }
    
//     const lockPromise = getNextInvoiceNumber(invoiceType);
//     invoiceNumberLocks.set(invoiceType, lockPromise);
    
//     try {
//         const result = await lockPromise;
//         return result;
//     } finally {
//         invoiceNumberLocks.delete(invoiceType);
//     }
// };
   const getNextInvoiceNumberWithLock = async (invoiceType) => {
    if (invoiceNumberLocks.has(invoiceType)) {
        await invoiceNumberLocks.get(invoiceType);
    }

    const lockPromise = getNextInvoiceNumber(invoiceType);
    invoiceNumberLocks.set(invoiceType, lockPromise);

    try {
        const result = await lockPromise;
        return result;
    } finally {
        invoiceNumberLocks.delete(invoiceType);
    }
};
   
    const saveInvoiceToDatabase = async (brandInfo, invoiceData) => {
        try {
            const invoiceCollection = collection(db, 'users', brandInfo.userId, 'invoices');
            await addDoc(invoiceCollection, invoiceData);
        } catch (error) {
            console.error('Error saving invoice to database:', error);
            throw error;
        }
    };

    // // Helper function to create PDF document
    // const createPDFDocument = (invoiceType, invoiceNumber, brandInfo, fromDate, toDate, items, total, taxDetails) => {
    //     const doc = new jsPDF();
    //     const invoiceDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0];
        
    //     // Header
    //     doc.setFontSize(20);
    //     doc.text(`TAX INVOICE`, 105, 15, null, null, 'center');
        
    //     // Company Information
    //     doc.setFontSize(10);
    //     doc.setFont("Helvetica", "normal");
    //     doc.text("UNITEE STUDIOS PRIVATE LIMITED", 10, 25);
    //     doc.text("Maharashtra, India", 10, 30);
    //     doc.text("GSTIN 27AADCU3575G1Z5", 10, 35);
    //     doc.text("rajprit@uniteeculture.com", 10, 40);
    //     doc.text("1ST FLOOR, PLOT 304/E/, 3, WAKHARIA BUILDING Vithalbhai Patel Road", 10, 45);
    //     doc.text("MUMBAI", 10, 50);
        
    //     // Invoice Details
    //     doc.text("Invoice Details", 150, 25, null, null, 'center');
    //     doc.setFontSize(10);
    //     doc.text(`Invoice Date: ${invoiceDate}`, 140, 30);
    //     doc.text(`Invoice Number: ${invoiceNumber}`, 140, 35);
    //     doc.text(`Period: ${fromDate} to ${toDate}`, 140, 40);
        
    //     // Billing and Shipping Information
    //     doc.text("Bill To / Ship To", 10, 60);
    //     doc.text(`Brand Name: ${brandInfo.brandName}`, 10, 65);
    //     doc.text(`Address: ${brandInfo.address || 'N/A'}`, 10, 70);
    //     doc.text(`State: ${brandInfo.state || 'N/A'}`, 10, 75);
    //     doc.text(`Pin Code: ${brandInfo.pincode || 'N/A'}`, 10, 80);
    //     doc.text(`GST Number: ${brandInfo.gstNumber || 'N/A'}`, 10, 85);
        
    //     // Items/Services Table
    //     let currentY = 95;
    //     autoTable(doc, {
    //         startY: currentY,
    //         head: [items.headers],
    //         body: items.data,
    //         theme: 'grid',
    //         styles: { fontSize: 10, cellPadding: 5 }
    //     });
        
    //     currentY = doc.lastAutoTable.finalY + 10;
        
    //     // Tax calculations
    //     const isMaharashtra = (brandInfo.state === "Maharashtra");
        
    //     // Tax Summary
    //     const taxTableBody = [];
    //     taxTableBody.push([
    //         taxDetails.description,
    //         taxDetails.baseAmount.toFixed(2),
    //         isMaharashtra ? taxDetails.cgstRate : taxDetails.igstRate,
    //         isMaharashtra ? taxDetails.cgstAmount.toFixed(2) : taxDetails.igstAmount.toFixed(2),
    //         isMaharashtra ? taxDetails.sgstRate : '',
    //         isMaharashtra ? taxDetails.sgstAmount.toFixed(2) : '',
    //         taxDetails.totalTaxAmount.toFixed(2)
    //     ]);
        
    //     autoTable(doc, {
    //         startY: currentY,
    //         head: [['Description', 'Taxable Value', 
    //             isMaharashtra ? 'CGST %' : 'IGST %', 
    //             isMaharashtra ? 'CGST Amt' : 'IGST Amt', 
    //             isMaharashtra ? 'SGST %' : '', 
    //             isMaharashtra ? 'SGST Amt' : '', 
    //             'Total Tax']],
    //         body: taxTableBody,
    //         theme: 'grid',
    //         styles: { fontSize: 9 }
    //     });
        
    //     currentY = doc.lastAutoTable.finalY + 10;
        
    //     // Draw a box for the total amount
    //     doc.rect(110, currentY, 90, 25);
        
    //     // Add text inside the box
    //     doc.text('Tax Amount:', 115, currentY + 5);
    //     doc.text(`${taxDetails.totalTaxAmount.toFixed(2)}`, 180, currentY + 5, { align: 'right' });
        
    //     doc.text('Amount before Tax:', 115, currentY + 10);
    //     doc.text(`${taxDetails.baseAmount.toFixed(2)}`, 180, currentY + 10, { align: 'right' });
        
    //     doc.setFontSize(12);
    //     doc.setFont('Helvetica', 'bold');
    //     doc.text('Total Amount:', 115, currentY + 15);
    //     doc.text(`${total.toFixed(2)}`, 180, currentY + 15, { align: 'right' });
        
    //     // Add amount in words
    //     doc.setFontSize(10);
    //     doc.setFont('Helvetica', 'normal');
    //     doc.text(`Amount in words: ${toWords.convert(Math.round(total))}`, 10, currentY + 30);
        
    //     // Footer
    //     const footerY = currentY + 45;
    //     doc.text("Thanks for your business.", 10, footerY);
    //     doc.text("For UNITEE STUDIOS PRIVATE LIMITED", 140, footerY);
    //     doc.text("Authorized Signatory", 140, footerY + 20);
        
    //     return doc;
    // };


    const createPDFDocument = (invoiceType, invoiceNumber, brandInfo, fromDate, toDate, items, total, taxDetails) => {
    const doc = new jsPDF();
    const invoiceDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0];
    
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 10;
    
    // Header function that can be reused on each page
    const addHeader = (isFirstPage = true) => {
        if (isFirstPage) {
            doc.setFontSize(20);
            doc.text(`TAX INVOICE`, 105, 15, null, null, 'center');
            
            // Company Information
            doc.setFontSize(10);
            doc.setFont("Helvetica", "normal");
            doc.text("UNITEE STUDIOS PRIVATE LIMITED", 10, 25);
            doc.text("Maharashtra, India", 10, 30);
            doc.text("GSTIN 27AADCU3575G1Z5", 10, 35);
            doc.text("rajprit@uniteeculture.com", 10, 40);
            doc.text("1ST FLOOR, PLOT 304/E/, 3, WAKHARIA BUILDING Vithalbhai Patel Road", 10, 45);
            doc.text("MUMBAI", 10, 50);
            
            // Invoice Details
            doc.text("Invoice Details", 150, 25, null, null, 'center');
            doc.setFontSize(10);
            doc.text(`Invoice Date: ${invoiceDate}`, 140, 30);
            doc.text(`Invoice Number: ${invoiceNumber}`, 140, 35);
            doc.text(`Period: ${fromDate} to ${toDate}`, 140, 40);
            
            // Billing and Shipping Information
            doc.text("Bill To / Ship To", 10, 60);
            doc.text(`Brand Name: ${brandInfo.brandName}`, 10, 65);
            doc.text(`Address: ${brandInfo.address || 'N/A'}`, 10, 70);
            doc.text(`State: ${brandInfo.state || 'N/A'}`, 10, 75);
            doc.text(`Pin Code: ${brandInfo.pincode || 'N/A'}`, 10, 80);
            doc.text(`GST Number: ${brandInfo.gstNumber || 'N/A'}`, 10, 85);
            
            return 95; // Return starting Y position for content
        } else {
            // Minimal header for continuation pages
            doc.setFontSize(10);
            doc.text(`${brandInfo.brandName} - Invoice: ${invoiceNumber} (Continued)`, 10, 15);
            return 25; // Return starting Y position for content
        }
    };
    
    // Initial header
    let currentY = addHeader(true);
    
    // Items/Services Table with page break handling
    autoTable(doc, {
        startY: currentY,
        head: [items.headers],
        body: items.data,
        theme: 'grid',
        styles: { fontSize: 10, cellPadding: 5 },
        didDrawPage: function(data) {
            // Add header to new pages if table continues
            if (data.pageNumber > 1) {
                addHeader(false);
            }
        }
    });
    
    currentY = doc.lastAutoTable.finalY + 10;
    
    // Check if we need a new page for tax summary
    if (currentY > pageHeight - 100) {
        doc.addPage();
        currentY = addHeader(false);
    }
    
    // Tax calculations
    const isMaharashtra = (brandInfo.state === "Maharashtra");
    
    // Tax Summary
    const taxTableBody = [];
    taxTableBody.push([
        taxDetails.description,
        taxDetails.baseAmount.toFixed(2),
        isMaharashtra ? taxDetails.cgstRate : taxDetails.igstRate,
        isMaharashtra ? taxDetails.cgstAmount.toFixed(2) : taxDetails.igstAmount.toFixed(2),
        isMaharashtra ? taxDetails.sgstRate : '',
        isMaharashtra ? taxDetails.sgstAmount.toFixed(2) : '',
        taxDetails.totalTaxAmount.toFixed(2)
    ]);
    
    autoTable(doc, {
        startY: currentY,
        head: [['Description', 'Taxable Value', 
            isMaharashtra ? 'CGST %' : 'IGST %', 
            isMaharashtra ? 'CGST Amt' : 'IGST Amt', 
            isMaharashtra ? 'SGST %' : '', 
            isMaharashtra ? 'SGST Amt' : '', 
            'Total Tax']],
        body: taxTableBody,
        theme: 'grid',
        styles: { fontSize: 9 }
    });
    
    currentY = doc.lastAutoTable.finalY + 10;
    
    // Check if we need a new page for totals
    if (currentY > pageHeight - 80) {
        doc.addPage();
        currentY = addHeader(false);
    }
    
    // Draw a box for the total amount
    doc.rect(110, currentY, 90, 25);
    
    // Add text inside the box
    doc.text('Tax Amount:', 115, currentY + 5);
    doc.text(`${taxDetails.totalTaxAmount.toFixed(2)}`, 180, currentY + 5, { align: 'right' });
    
    doc.text('Amount before Tax:', 115, currentY + 10);
    doc.text(`${taxDetails.baseAmount.toFixed(2)}`, 180, currentY + 10, { align: 'right' });
    
    doc.setFontSize(12);
    doc.setFont('Helvetica', 'bold');
    doc.text('Total Amount:', 115, currentY + 15);
    doc.text(`${total.toFixed(2)}`, 180, currentY + 15, { align: 'right' });
    
    // Add amount in words
    doc.setFontSize(10);
    doc.setFont('Helvetica', 'normal');
    doc.text(`Amount in words: ${toWords.convert(Math.round(total))}`, 10, currentY + 30);
    
    // Footer
    const footerY = currentY + 45;
    
    // Check if we need a new page for footer
    if (footerY > pageHeight - 30) {
        doc.addPage();
        const newFooterY = 20;
        doc.text("Thanks for your business.", 10, newFooterY);
        doc.text("For UNITEE STUDIOS PRIVATE LIMITED", 140, newFooterY);
        doc.text("Authorized Signatory", 140, newFooterY + 20);
    } else {
        doc.text("Thanks for your business.", 10, footerY);
        doc.text("For UNITEE STUDIOS PRIVATE LIMITED", 140, footerY);
        doc.text("Authorized Signatory", 140, footerY + 20);
    }
    
    return doc;
};

    const generateMonthlyInvoices = async () => {
    if (!fromDate || !toDate) {
        alert('Please select both From Date and To Date to generate invoices.');
        return;
    }

    
    setGenerating(true);
    
    try {
        // Get userIds to process based on selected brand
        let userIdsToProcess = [];
        
        if (selectedBrand === 'All') {
            userIdsToProcess = Array.from(window.brandInfoMap?.keys() || []);
        } else {
            // Get all userIds with the selected brandName
            userIdsToProcess = Array.from(window.brandInfoMap?.entries() || [])
                .filter(([userId, info]) => info.brandName === selectedBrand)
                .map(([userId]) => userId);
        }

        let totalBrandsProcessed = 0;

        const totalToProcess = userIdsToProcess.length;
let processed = 0;
setProgress(0);
setProgressLabel('Starting invoice generation...');

        for (const userId of userIdsToProcess) {
            const brandInfo = window.brandInfoMap?.get(userId);
            if (!brandInfo) {
                console.warn(`Brand information not found for userId ${userId}`);
                continue;
            }




            // Filter invoices for current userId (not brandName)
            const brandFilteredInvoices = invoices.filter(inv => 
                inv.userId === userId &&
                (!fromDate || inv.orderDate >= fromDate) &&
                (!toDate || inv.orderDate <= toDate)
            );

            if (brandFilteredInvoices.length === 0) {
                console.log(`No invoices found for userId: ${userId} (${brandInfo.brandName})`);
                continue;
            }

            // Calculate totals for this brand
            const brandTotalQuantity = brandFilteredInvoices.reduce((sum, inv) => sum + inv.totalQuantity, 0);
            // const brandTotalItemsPrice = brandFilteredInvoices.reduce((sum, inv) => sum + inv.totalItemsPrice, 0);
           
const brandTotalItemsPrice = brandFilteredInvoices.reduce((sum, inv) => {
    const invoiceItemsTotal = inv.order_items.reduce((itemSum, item) => {
        return itemSum + ((parseFloat(item.itemTotalPrice) || 0) * (parseInt(item.units) || 0));
    }, 0);
    return sum + invoiceItemsTotal;
}, 0);
           
            const brandTotalShippingPrice = brandFilteredInvoices.reduce((sum, inv) => sum + (inv.totalShippingCharges || 0), 0);
            const brandTotalPackagingPrice = brandFilteredInvoices.reduce((sum, inv) => sum + (inv.totalPackagingCharges || 0), 0);
            
            const isMaharashtra = (brandInfo.state === "Maharashtra");
            const generatedInvoices = {};

          const excelData = {
    summary: [],
    invoiceDetails: [],
    orderDetails: [],
    productDetails: [] // Initialize productDetails array
};
            
            // 1. PRODUCTS INVOICE
            // if (brandTotalItemsPrice > 0) {
            //     const productInvoiceNumber = await getNextInvoiceNumberWithLock('PRD');
                
            //     // Aggregate all items by type for this brand
            //     const itemsAggregation = {};
            //     brandFilteredInvoices.forEach(invoice => {
            //         invoice.order_items.forEach(item => {
            //             let itemType = 'Oversized Tshirt';
            //             const productName = item.productName;
            //             const variantName = (item.variant_name || '').toLowerCase();
                        
            //             // if (productName.includes('baby') || variantName.includes('baby') || 
            //             //     productName.includes('crop') || variantName.includes('crop')) {
            //             //     itemType = 'Baby Tees';
            //             // }   
                        
            //             if (!itemsAggregation[itemType]) {
            //                 itemsAggregation[itemType] = {
            //                     quantity: 0,
            //                     totalPrice: 0,
            //                     hsnCode: '610910'
            //                 };
            //             }
                        
            //             itemsAggregation[itemType].quantity += parseInt(item.units) || 0;
            //             itemsAggregation[itemType].totalPrice += (parseFloat(item.itemTotalPrice) || 0) * (parseInt(item.units) || 0);
            //         });
            //     });
                
            //     const productItems = {
            //         headers: ['Item Description', 'HSN Code', 'Quantity', 'Rate', 'Amount'],
            //         data: Object.entries(itemsAggregation).map(([itemType, data]) => [
            //             itemType,
            //             data.hsnCode,
            //             data.quantity,
            //             `${(data.totalPrice / data.quantity).toFixed(2)}`,
            //             `${data.totalPrice.toFixed(2)}`
            //         ])
            //     };

            if (brandTotalItemsPrice > 0) {
    const productInvoiceNumber = await getNextInvoiceNumberWithLock('PRD');
    
    // Aggregate all items by product name and GSM for this brand
    const itemsAggregation = {};
    brandFilteredInvoices.forEach(invoice => {
        invoice.order_items.forEach(item => {
            // Get product name from design object or fall back to 'Oversized Tshirt'
            let productName = 'Oversized Tshirt';
            if (item.design && item.design.productName) {
                productName = item.design.productName;
            }
            
            // Get GSM and extract numeric value
            let gsm = '240';
            if (item.design && item.design.productGSM) {
                // Extract numeric part from "240 GSM" or "240"
                const gsmMatch = item.design.productGSM.toString().match(/\d+/);
                gsm = gsmMatch ? gsmMatch[0] : '240';
            }


                     excelData.productDetails.push({
                'Order ID': invoice.id,
                'Product Name': productName,
                'GSM': gsm,
                'SKU': item.sku || 'N/A',
                'HSN Code': '610910',
                'Quantity': parseInt(item.units) || 0,
                'Unit Price': (parseFloat(item.itemTotalPrice) || 0).toFixed(2),
                'Total Price': ((parseFloat(item.itemTotalPrice) || 0) * (parseInt(item.units) || 0)).toFixed(2)
            });
            
            const key = `${productName}|${gsm}`; // Use combination of product name and GSM as key
            
            if (!itemsAggregation[key]) {
                itemsAggregation[key] = {
                    productName: productName,
                    gsm: gsm,
                    quantity: 0,
                    totalPrice: 0,
                    hsnCode: '610910',
                    skus: [] // Store all SKUs for this product-GSM combination
                };
            }
            
            itemsAggregation[key].quantity += parseInt(item.units) || 0;
            itemsAggregation[key].totalPrice += (parseFloat(item.itemTotalPrice) || 0) * (parseInt(item.units) || 0);
            
            // Add SKU if not already in the list
            const sku = item.sku || 'N/A';
            if (!itemsAggregation[key].skus.includes(sku)) {
                itemsAggregation[key].skus.push(sku);
            }
        });
    });
    

    const productItems = {
        headers: ['Item Description', 'HSN Code', 'Quantity', 'Rate', 'Amount'],
        data: Object.values(itemsAggregation).map(data => [
            `${data.productName} (${data.gsm} GSM)`,
            data.hsnCode,
            data.quantity,
            `${(data.totalPrice / data.quantity).toFixed(2)}`,
            `${data.totalPrice.toFixed(2)}`
        ])
    };
                
                // Tax calculations for products (5% GST)
                // const productBaseAmount = brandTotalItemsPrice / 1.05;
                // const productTaxAmount = brandTotalItemsPrice - productBaseAmount;

const productBaseAmount = brandTotalItemsPrice;
const productTaxAmount = brandTotalItemsPrice * 0.05;
const productTotalWithTax = brandTotalItemsPrice + productTaxAmount;
                
                const productTaxDetails = {
                    description: 'Products (HSN: 610910)',
                    baseAmount: productBaseAmount,
                    totalTaxAmount: productTaxAmount,
                    cgstRate: isMaharashtra ? '2.5%' : '',
                    sgstRate: isMaharashtra ? '2.5%' : '',
                    igstRate: isMaharashtra ? '' : '5%',
                    cgstAmount: isMaharashtra ? productTaxAmount / 2 : 0,
                    sgstAmount: isMaharashtra ? productTaxAmount / 2 : 0,
                    igstAmount: isMaharashtra ? 0 : productTaxAmount
                };
                
                const productDoc = createPDFDocument('PRODUCT', productInvoiceNumber, brandInfo, fromDate, toDate, productItems, productTotalWithTax, productTaxDetails);
                const productPdfBlob = productDoc.output('blob');
                 const productPdfUrl = await uploadPDFToStorage(productPdfBlob, 'PRD', productInvoiceNumber, brandInfo.brandName, userId); // Pass userId
                
                generatedInvoices.product = {
                    invoiceNumber: productInvoiceNumber,
                    invoiceUrl: productPdfUrl,
                    amount: productTotalWithTax,
                    type: 'PRODUCT'
                };

                    excelData.invoiceDetails.push({
                    'Invoice Type': 'PRODUCT',
                    'Invoice Number': productInvoiceNumber,
                    'Base Amount': productBaseAmount.toFixed(2),
                    'Tax Amount': productTaxAmount.toFixed(2),
                    'Total Amount': productTotalWithTax.toFixed(2),
                    'CGST Rate': productTaxDetails.cgstRate,
                    'CGST Amount': productTaxDetails.cgstAmount.toFixed(2),
                    'SGST Rate': productTaxDetails.sgstRate,
                    'SGST Amount': productTaxDetails.sgstAmount.toFixed(2),
                    'IGST Rate': productTaxDetails.igstRate,
                    'IGST Amount': productTaxDetails.igstAmount.toFixed(2)
                });
                

            }
            
            // 2. SHIPPING INVOICE
            if (brandTotalShippingPrice > 0) {
                const shippingInvoiceNumber = await getNextInvoiceNumberWithLock('SHP');
                
                const shippingItems = {
                    headers: ['Service Description', 'SAC Code', 'Amount'],
                    data: [['Shipping Charges', '9965', `${brandTotalShippingPrice.toFixed(2)}`]]
                };
                
                // Tax calculations for shipping (18% GST)
                const shippingBaseAmount = brandTotalShippingPrice / 1.18;
                const shippingTaxAmount = brandTotalShippingPrice - shippingBaseAmount;
                
                const shippingTaxDetails = {
                    description: 'Shipping Charges (SAC: 9965)',
                    baseAmount: shippingBaseAmount,
                    totalTaxAmount: shippingTaxAmount,
                    cgstRate: isMaharashtra ? '9%' : '',
                    sgstRate: isMaharashtra ? '9%' : '',
                    igstRate: isMaharashtra ? '' : '18%',
                    cgstAmount: isMaharashtra ? shippingTaxAmount / 2 : 0,
                    sgstAmount: isMaharashtra ? shippingTaxAmount / 2 : 0,
                    igstAmount: isMaharashtra ? 0 : shippingTaxAmount
                };
                
                const shippingDoc = createPDFDocument('SHIPPING', shippingInvoiceNumber, brandInfo, fromDate, toDate, shippingItems, brandTotalShippingPrice, shippingTaxDetails);
                const shippingPdfBlob = shippingDoc.output('blob');
                const shippingPdfUrl = await uploadPDFToStorage(shippingPdfBlob, 'SHP', shippingInvoiceNumber, brandInfo.brandName, userId); // Pass userId
                
                generatedInvoices.shipping = {
                    invoiceNumber: shippingInvoiceNumber,
                    invoiceUrl: shippingPdfUrl,
                    amount: brandTotalShippingPrice,
                    type: 'SHIPPING'
                };

                    excelData.invoiceDetails.push({
                    'Invoice Type': 'SHIPPING',
                    'Invoice Number': shippingInvoiceNumber,
                    'Base Amount': shippingBaseAmount.toFixed(2),
                    'Tax Amount': shippingTaxAmount.toFixed(2),
                    'Total Amount': brandTotalShippingPrice.toFixed(2),
                    'CGST Rate': shippingTaxDetails.cgstRate,
                    'CGST Amount': shippingTaxDetails.cgstAmount.toFixed(2),
                    'SGST Rate': shippingTaxDetails.sgstRate,
                    'SGST Amount': shippingTaxDetails.sgstAmount.toFixed(2),
                    'IGST Rate': shippingTaxDetails.igstRate,
                    'IGST Amount': shippingTaxDetails.igstAmount.toFixed(2)
                });
                

            }
            
            // 3. PACKAGING INVOICE
            if (brandTotalPackagingPrice > 0) {
                const packagingInvoiceNumber = await getNextInvoiceNumberWithLock('PKG');
                
                const packagingQuantity = brandFilteredInvoices.reduce((sum, inv) => {
                    return sum + (inv.completeOrderData.order_items || []).filter(item => item.RTOinventory === true).length;
                }, 0);
                
                const packagingItems = {
                    headers: ['Service Description', 'HSN/SAC Code', 'Quantity', 'Rate', 'Amount'],
                    data: [['Packing and Forwarding', '99854', packagingQuantity, '55.46', `${brandTotalPackagingPrice.toFixed(2)}`]]
                };
                
                // Tax calculations for packaging (18% GST)
                const packagingBaseAmount = brandTotalPackagingPrice / 1.18;
                const packagingTaxAmount = brandTotalPackagingPrice - packagingBaseAmount;
                
                const packagingTaxDetails = {
                    description: 'Packing & Forwarding (HSN: 99854)',
                    baseAmount: packagingBaseAmount,
                    totalTaxAmount: packagingTaxAmount,
                    cgstRate: isMaharashtra ? '9%' : '',
                    sgstRate: isMaharashtra ? '9%' : '',
                    igstRate: isMaharashtra ? '' : '18%',
                    cgstAmount: isMaharashtra ? packagingTaxAmount / 2 : 0,
                    sgstAmount: isMaharashtra ? packagingTaxAmount / 2 : 0,
                    igstAmount: isMaharashtra ? 0 : packagingTaxAmount
                };
                
                const packagingDoc = createPDFDocument('PACKAGING', packagingInvoiceNumber, brandInfo, fromDate, toDate, packagingItems, brandTotalPackagingPrice, packagingTaxDetails);
                const packagingPdfBlob = packagingDoc.output('blob');
                const packagingPdfUrl = await uploadPDFToStorage(packagingPdfBlob, 'PKG', packagingInvoiceNumber, brandInfo.brandName, userId); // Pass userId
                
                generatedInvoices.packaging = {
                    invoiceNumber: packagingInvoiceNumber,
                    invoiceUrl: packagingPdfUrl,
                    amount: brandTotalPackagingPrice,
                    type: 'PACKING and FORWARDING'
                };

                    excelData.invoiceDetails.push({
                    'Invoice Type': 'PACKING and FORWARDING',
                    'Invoice Number': packagingInvoiceNumber,
                    'Base Amount': packagingBaseAmount.toFixed(2),
                    'Tax Amount': packagingTaxAmount.toFixed(2),
                    'Total Amount': brandTotalPackagingPrice.toFixed(2),
                    'CGST Rate': packagingTaxDetails.cgstRate,
                    'CGST Amount': packagingTaxDetails.cgstAmount.toFixed(2),
                    'SGST Rate': packagingTaxDetails.sgstRate,
                    'SGST Amount': packagingTaxDetails.sgstAmount.toFixed(2),
                    'IGST Rate': packagingTaxDetails.igstRate,
                    'IGST Amount': packagingTaxDetails.igstAmount.toFixed(2)
                });
                
            }


            const brandTotalBrandingPrice = brandFilteredInvoices.reduce((sum, inv) => sum + (inv.totalBrandingCharges || 0), 0);

            if (brandTotalBrandingPrice > 0) {
    const brandingInvoiceNumber = await getNextInvoiceNumberWithLock('BRN');
    
    const brandingItems = {
        headers: ['Service Description', 'SAC Code', 'Amount'],
        data: [['Branding Charges', '39232100', `${brandTotalBrandingPrice.toFixed(2)}`]]
    };
    
    // Tax calculations for branding (18% GST already included)
    const brandingBaseAmount = brandTotalBrandingPrice / 1.18;
    const brandingTaxAmount = brandTotalBrandingPrice - brandingBaseAmount;
    
    const brandingTaxDetails = {
        description: 'Branding Charges (SAC: 39232100)',
        baseAmount: brandingBaseAmount,
        totalTaxAmount: brandingTaxAmount,
        cgstRate: isMaharashtra ? '9%' : '',
        sgstRate: isMaharashtra ? '9%' : '',
        igstRate: isMaharashtra ? '' : '18%',
        cgstAmount: isMaharashtra ? brandingTaxAmount / 2 : 0,
        sgstAmount: isMaharashtra ? brandingTaxAmount / 2 : 0,
        igstAmount: isMaharashtra ? 0 : brandingTaxAmount
    };
    
    const brandingDoc = createPDFDocument('BRANDING', brandingInvoiceNumber, brandInfo, fromDate, toDate, brandingItems, brandTotalBrandingPrice, brandingTaxDetails);
    const brandingPdfBlob = brandingDoc.output('blob');
    const brandingPdfUrl = await uploadPDFToStorage(brandingPdfBlob, 'BRN', brandingInvoiceNumber, brandInfo.brandName, userId);
    
    generatedInvoices.branding = {
        invoiceNumber: brandingInvoiceNumber,
        invoiceUrl: brandingPdfUrl,
        amount: brandTotalBrandingPrice,
        type: 'BRANDING'
    };

    excelData.invoiceDetails.push({
        'Invoice Type': 'BRANDING',
        'Invoice Number': brandingInvoiceNumber,
        'Base Amount': brandingBaseAmount.toFixed(2),
        'Tax Amount': brandingTaxAmount.toFixed(2),
        'Total Amount': brandTotalBrandingPrice.toFixed(2),
        'CGST Rate': brandingTaxDetails.cgstRate,
        'CGST Amount': brandingTaxDetails.cgstAmount.toFixed(2),
        'SGST Rate': brandingTaxDetails.sgstRate,
        'SGST Amount': brandingTaxDetails.sgstAmount.toFixed(2),
        'IGST Rate': brandingTaxDetails.igstRate,
        'IGST Amount': brandingTaxDetails.igstAmount.toFixed(2)
    });
}

            excelData.summary = [{
                'Brand Name': brandInfo.brandName,
                'Period From': fromDate,
                'Period To': toDate,
                'Total Orders': brandFilteredInvoices.length,
                'Total Items': brandTotalQuantity,
                'Total Items Amount': (brandTotalItemsPrice + (brandTotalItemsPrice * 0.05)).toFixed(2),
                'Total Shipping Amount': brandTotalShippingPrice.toFixed(2),
                'Total Packaging Amount': brandTotalPackagingPrice.toFixed(2),
                'Total Branding Amount': brandTotalBrandingPrice.toFixed(2),
                'Grand Total': ((brandTotalItemsPrice + (brandTotalItemsPrice * 0.05)) + brandTotalShippingPrice + brandTotalPackagingPrice + brandTotalBrandingPrice).toFixed(2),
                'Generation Date': new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]
            }];
            
            // Prepare Excel Order Details Data
            excelData.orderDetails = brandFilteredInvoices.map(inv => ({
                'Order ID': inv.id,
                'Order Date': inv.orderDate,
                // 'Customer Name': inv.customerName || 'N/A',
                'Total Quantity': inv.totalQuantity,
                'Items Price': inv.totalItemsPrice.toFixed(2),
                'Shipping Charges': (inv.totalShippingCharges || 0).toFixed(2),
                'Packaging Charges': (inv.totalPackagingCharges || 0).toFixed(2),
                'Order Total': (inv.totalItemsPrice + (inv.totalShippingCharges || 0) + (inv.totalPackagingCharges || 0)).toFixed(2)
            }));

             const excelBlob = await generateExcelReport(excelData, brandInfo.brandName, fromDate, toDate);
            const excelUrl = await uploadExcelToStorage(excelBlob, brandInfo.brandName, fromDate, toDate);
            
            // Save invoice data to this brand's database
            const invoiceData = {
                brandName: brandInfo.brandName,
                brandUserId: brandInfo.userId,
                fromDate: fromDate,
                toDate: toDate,
                generationDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                invoices: generatedInvoices,
                excelReportUrl: excelUrl, // ADD THIS LINE - Excel report URL
                totalAmount: (brandTotalItemsPrice + (brandTotalItemsPrice * 0.05)) + brandTotalShippingPrice + brandTotalPackagingPrice + brandTotalBrandingPrice,
                orderIds: brandFilteredInvoices.map(inv => inv.id),
                summary: {
                    totalOrders: brandFilteredInvoices.length,
                    totalItems: brandTotalQuantity,
                    totalItemsAmount: (brandTotalItemsPrice + (brandTotalItemsPrice * 0.05)),
                    totalShippingAmount: brandTotalShippingPrice,
                    totalPackagingAmount: brandTotalPackagingPrice,
                    totalBrandingAmount: brandTotalBrandingPrice
                }
            };
            
            await saveInvoiceToDatabase(brandInfo, invoiceData);
            totalBrandsProcessed++;
            
            console.log(`Invoices generated and saved for userId: ${userId} (${brandInfo.brandName})`);

            processed++;
setProgress(Math.round((processed / totalToProcess) * 100));
setProgressLabel(`Generated invoices for ${processed}/${totalToProcess} brands`);
        }
        
        if (totalBrandsProcessed > 0) {
            alert(`Successfully generated invoices for ${totalBrandsProcessed} brand(s) and saved to their respective databases!`);
        } else {
            alert('No invoices were generated. Please check the selected criteria and try again.');
        }
        
    } catch (error) {
        console.error("Error generating invoices:", error);
        alert("Failed to generate invoices. Please try again.");
    } finally {
          setGenerating(false);
    setProgress(0);
    setProgressLabel('');
    }
};


const downloadSummaryReport = async () => {
    if (!fromDate || !toDate) {
        alert('Please select both From Date and To Date to generate summary report.');
        return;
    }

    setGenerating(true);
    
   
        // Get all brands or selected brand
    try {
        // Get userIds to process based on selected brand
        let userIdsToProcess = [];
        
        if (selectedBrand === 'All') {
            userIdsToProcess = Array.from(window.brandInfoMap?.keys() || []);
        } else {
            // Get all userIds with the selected brandName
            userIdsToProcess = Array.from(window.brandInfoMap?.entries() || [])
                .filter(([userId, info]) => info.brandName === selectedBrand)
                .map(([userId]) => userId);
        }

        const summaryData = {
            overallSummary: [],
            allProducts: [],
            allShipping: [],
            allPackaging: [],
            allBranding: [],
            brandWiseTotals: [],
            orderDetails: [],
            taxBreakdown: []
        };

        let grandTotalItems = 0;
        let grandTotalItemsAmount = 0;
        let grandTotalShippingAmount = 0;
        let grandTotalPackagingAmount = 0;
        let grandTotalBrandingAmount = 0;
        let grandTotalOrders = 0;

       for (const userId of userIdsToProcess) {
            const brandInfo = window.brandInfoMap?.get(userId);
            if (!brandInfo) {
                console.warn(`Brand information not found for userId ${userId}`);
                continue;
            }

            // Filter invoices for current userId (not brandName)
            const brandFilteredInvoices = invoices.filter(inv => 
                inv.userId === userId &&
                (!fromDate || inv.orderDate >= fromDate) &&
                (!toDate || inv.orderDate <= toDate)
            );

            if (brandFilteredInvoices.length === 0) {
                continue;
            }

            // Calculate totals for this brand
            const brandName = brandInfo.brandName;
            const brandTotalQuantity = brandFilteredInvoices.reduce((sum, inv) => sum + inv.totalQuantity, 0);
            // const brandTotalItemsPrice = brandFilteredInvoices.reduce((sum, inv) => sum + inv.totalItemsPrice, 0);
           
            const brandTotalItemsPrice = brandFilteredInvoices.reduce((sum, inv) => {
    const invoiceItemsTotal = inv.order_items.reduce((itemSum, item) => {
        return itemSum + ((parseFloat(item.itemTotalPrice) || 0) * (parseInt(item.units) || 0));
    }, 0);
    return sum + invoiceItemsTotal;
}, 0);
            
            const brandTotalShippingPrice = brandFilteredInvoices.reduce((sum, inv) => sum + (inv.totalShippingCharges || 0), 0);
            const brandTotalPackagingPrice = brandFilteredInvoices.reduce((sum, inv) => sum + (inv.totalPackagingCharges || 0), 0);
            const brandTotalBrandingPrice = brandFilteredInvoices.reduce((sum, inv) => sum + (inv.totalBrandingCharges || 0), 0);
             grandTotalBrandingAmount += brandTotalBrandingPrice;
            const isMaharashtra = (brandInfo.state === "Maharashtra");

            // Add to grand totals
            grandTotalItems += brandTotalQuantity;
            grandTotalItemsAmount += (brandTotalItemsPrice + (brandTotalItemsPrice * 0.05));
            grandTotalShippingAmount += brandTotalShippingPrice;
            grandTotalPackagingAmount += brandTotalPackagingPrice;
            grandTotalOrders += brandFilteredInvoices.length;

            // DETAILED PRODUCTS DATA - Individual items from all orders
            // brandFilteredInvoices.forEach(invoice => {
            //     invoice.order_items.forEach(item => {
            //         let itemType = 'Oversized Tshirt';
            //         const productName = (item.product_name || '').toLowerCase();
            //         const variantName = (item.variant_name || '').toLowerCase();
                    


            //         summaryData.allProducts.push({
            //             'Brand Name': brandName,
            //             'Order ID': invoice.id,
            //             'Order Date': invoice.orderDate,
            //             'Product Name': item.product_name || 'N/A',
            //             'Variant Name': item.variant_name || 'N/A',
            //             'Item Type': itemType,
            //             'HSN Code': '610910',
            //             'Quantity': parseInt(item.units) || 0,
            //             'Unit Price': (parseFloat(item.itemTotalPrice) || 0),
            //            'Total Price': (parseFloat(item.itemTotalPrice) || 0) * (parseInt(item.units) || 0),
            //             'Customer Name': invoice.customerName || 'N/A'
            //         });
            //     });
            // });


            // DETAILED PRODUCTS DATA - Individual items from all orders
brandFilteredInvoices.forEach(invoice => {
    invoice.order_items.forEach(item => {
        let productName = 'Oversized Tshirt';
        if (item.design && item.design.productName) {
            productName = item.design.productName;
        }
        
        // Extract GSM
        let gsm = '240';
        if (item.design && item.design.productGSM) {
            const gsmMatch = item.design.productGSM.toString().match(/\d+/);
            gsm = gsmMatch ? gsmMatch[0] : '240';
        }

        summaryData.allProducts.push({
            'Brand Name': brandName,
            'Order ID': invoice.id,
            'Order Date': invoice.orderDate,
            'Product Name': productName,
            'GSM': gsm,
            'SKU': item.sku || 'N/A',
            'Variant Name': item.variant_name || 'N/A',
            'HSN Code': '610910',
            'Quantity': parseInt(item.units) || 0,
            'Unit Price': (parseFloat(item.itemTotalPrice) || 0),
            'Total Price': (parseFloat(item.itemTotalPrice) || 0) * (parseInt(item.units) || 0),
            'Customer Name': invoice.customerName || 'N/A'
        });
    });
});

            // DETAILED SHIPPING DATA - Each order's shipping
            brandFilteredInvoices.forEach(invoice => {
                if (invoice.totalShippingCharges && invoice.totalShippingCharges > 0) {
                    const shippingBaseAmount = invoice.totalShippingCharges / 1.18;
                    const shippingTaxAmount = invoice.totalShippingCharges - shippingBaseAmount;

                    summaryData.allShipping.push({
                        'Brand Name': brandName,
                        'Order ID': invoice.id,
                        'Order Date': invoice.orderDate,
                        'Service Description': 'Shipping Charges',
                        'SAC Code': '9965',
                        'Base Amount': shippingBaseAmount.toFixed(2),
                        'Tax Rate': '18%',
                        'CGST': isMaharashtra ? (shippingTaxAmount / 2).toFixed(2) : '0.00',
                        'SGST': isMaharashtra ? (shippingTaxAmount / 2).toFixed(2) : '0.00',
                        'IGST': isMaharashtra ? '0.00' : shippingTaxAmount.toFixed(2),
                        'Total Tax': shippingTaxAmount.toFixed(2),
                        'Total Amount': invoice.totalShippingCharges.toFixed(2),
                        'Customer Name': invoice.customerName || 'N/A'
                    });
                }
            });

            // DETAILED PACKAGING DATA - Each order's packaging
            brandFilteredInvoices.forEach(invoice => {
                if (invoice.totalPackagingCharges && invoice.totalPackagingCharges > 0) {
                    const packagingBaseAmount = invoice.totalPackagingCharges / 1.18;
                    const packagingTaxAmount = invoice.totalPackagingCharges - packagingBaseAmount;
                    
                    const packagingQuantity = (invoice.completeOrderData.order_items || [])
                        .filter(item => item.RTOinventory === true).length;

                    summaryData.allPackaging.push({
                        'Brand Name': brandName,
                        'Order ID': invoice.id,
                        'Order Date': invoice.orderDate,
                        'Service Description': 'Packaging and Forwarding',
                        'HSN/SAC Code': '99854',
                        'Quantity': packagingQuantity,
                        'Rate per Unit': '55.46',
                        'Base Amount': packagingBaseAmount.toFixed(2),
                        'Tax Rate': '18%',
                        'CGST': isMaharashtra ? (packagingTaxAmount / 2).toFixed(2) : '0.00',
                        'SGST': isMaharashtra ? (packagingTaxAmount / 2).toFixed(2) : '0.00',
                        'IGST': isMaharashtra ? '0.00' : packagingTaxAmount.toFixed(2),
                        'Total Tax': packagingTaxAmount.toFixed(2),
                        'Total Amount': invoice.totalPackagingCharges.toFixed(2),
                        'Customer Name': invoice.customerName || 'N/A'
                    });
                }
            });


            

// Add branding details for each order
brandFilteredInvoices.forEach(invoice => {
    if (invoice.totalBrandingCharges && invoice.totalBrandingCharges > 0) {
        const brandingBaseAmount = invoice.totalBrandingCharges / 1.18;
        const brandingTaxAmount = invoice.totalBrandingCharges - brandingBaseAmount;

        summaryData.allBranding.push({
            'Brand Name': brandName,
            'Order ID': invoice.id,
            'Order Date': invoice.orderDate,
            'Service Description': 'Branding Charges',
            'SAC Code': '39232100',
            'Base Amount': brandingBaseAmount.toFixed(2),
            'Tax Rate': '18%',
            'CGST': isMaharashtra ? (brandingTaxAmount / 2).toFixed(2) : '0.00',
            'SGST': isMaharashtra ? (brandingTaxAmount / 2).toFixed(2) : '0.00',
            'IGST': isMaharashtra ? '0.00' : brandingTaxAmount.toFixed(2),
            'Total Tax': brandingTaxAmount.toFixed(2),
            'Total Amount': invoice.totalBrandingCharges.toFixed(2),
            'Customer Name': invoice.customerName || 'N/A'
        });
    }
});

            // Brand-wise totals summary
            summaryData.brandWiseTotals.push({
                'Brand Name': brandName,
                'State': brandInfo.state,
                'Total Orders': brandFilteredInvoices.length,
                'Total Items': brandTotalQuantity,
                'Items Amount': (brandTotalItemsPrice + (brandTotalItemsPrice * 0.05)).toFixed(2),
                'Shipping Amount': brandTotalShippingPrice.toFixed(2),
                'Packaging Amount': brandTotalPackagingPrice.toFixed(2),
                'Branding Amount': brandTotalBrandingPrice.toFixed(2),
                'Brand Total': ((brandTotalItemsPrice + (brandTotalItemsPrice * 0.05)) + brandTotalShippingPrice + brandTotalPackagingPrice + brandTotalBrandingPrice).toFixed(2)
            });

            // Order details
            brandFilteredInvoices.forEach(inv => {
                summaryData.orderDetails.push({
                    'Brand Name': brandName,
                    'Order ID': inv.id,
                    'Order Date': inv.orderDate,
                    // 'Customer Name': inv.customerName || 'N/A',
                    'Total Quantity': inv.totalQuantity,
                    'Items Price': inv.totalItemsPrice.toFixed(2),
                    'Shipping Charges': (inv.totalShippingCharges || 0).toFixed(2),
                    'Packaging Charges': (inv.totalPackagingCharges || 0).toFixed(2),
                    'Branding Charges': (inv.totalBrandingCharges || 0).toFixed(2),
                   'Order Total': (inv.totalItemsPrice + (inv.totalShippingCharges || 0) + (inv.totalPackagingCharges || 0) + (inv.totalBrandingCharges || 0)).toFixed(2),
                    
                });
            });

            // Tax breakdown by brand and type
            if (brandTotalItemsPrice > 0) {
const productBaseAmount = brandTotalItemsPrice;
const productTaxAmount = brandTotalItemsPrice * 0.05;
const productTotalWithTax = brandTotalItemsPrice + productTaxAmount;
                
                summaryData.taxBreakdown.push({
                    'Brand Name': brandName,
                    'Tax Type': 'Products (5% GST)',
                    'Base Amount': productBaseAmount.toFixed(2),
                    'CGST': isMaharashtra ? (productTaxAmount / 2).toFixed(2) : '0.00',
                    'SGST': isMaharashtra ? (productTaxAmount / 2).toFixed(2) : '0.00',
                    'IGST': isMaharashtra ? '0.00' : productTaxAmount.toFixed(2),
                    'Total Tax': productTaxAmount.toFixed(2),
                    'Total Amount': productTotalWithTax.toFixed(2)
                });
            }

            if (brandTotalShippingPrice > 0) {
                const shippingBaseAmount = brandTotalShippingPrice / 1.18;
                const shippingTaxAmount = brandTotalShippingPrice - shippingBaseAmount;
                
                summaryData.taxBreakdown.push({
                    'Brand Name': brandName,
                    'Tax Type': 'Shipping (18% GST)',
                    'Base Amount': shippingBaseAmount.toFixed(2),
                    'CGST': isMaharashtra ? (shippingTaxAmount / 2).toFixed(2) : '0.00',
                    'SGST': isMaharashtra ? (shippingTaxAmount / 2).toFixed(2) : '0.00',
                    'IGST': isMaharashtra ? '0.00' : shippingTaxAmount.toFixed(2),
                    'Total Tax': shippingTaxAmount.toFixed(2),
                    'Total Amount': brandTotalShippingPrice.toFixed(2)
                });
            }

            if (brandTotalPackagingPrice > 0) {
                const packagingBaseAmount = brandTotalPackagingPrice / 1.18;
                const packagingTaxAmount = brandTotalPackagingPrice - packagingBaseAmount;
                
                summaryData.taxBreakdown.push({
                    'Brand Name': brandName,
                    'Tax Type': 'Packaging (18% GST)',
                    'Base Amount': packagingBaseAmount.toFixed(2),
                    'CGST': isMaharashtra ? (packagingTaxAmount / 2).toFixed(2) : '0.00',
                    'SGST': isMaharashtra ? (packagingTaxAmount / 2).toFixed(2) : '0.00',
                    'IGST': isMaharashtra ? '0.00' : packagingTaxAmount.toFixed(2),
                    'Total Tax': packagingTaxAmount.toFixed(2),
                    'Total Amount': brandTotalPackagingPrice.toFixed(2)
                });
            }


            if (brandTotalBrandingPrice > 0) {
    const brandingBaseAmount = brandTotalBrandingPrice / 1.18;
    const brandingTaxAmount = brandTotalBrandingPrice - brandingBaseAmount;
    
    summaryData.taxBreakdown.push({
        'Brand Name': brandName,
        'Tax Type': 'Branding (18% GST)',
        'Base Amount': brandingBaseAmount.toFixed(2),
        'CGST': isMaharashtra ? (brandingTaxAmount / 2).toFixed(2) : '0.00',
        'SGST': isMaharashtra ? (brandingTaxAmount / 2).toFixed(2) : '0.00',
        'IGST': isMaharashtra ? '0.00' : brandingTaxAmount.toFixed(2),
        'Total Tax': brandingTaxAmount.toFixed(2),
        'Total Amount': brandTotalBrandingPrice.toFixed(2)
    });
}
        }

        // Overall summary
        summaryData.overallSummary = [{
            'Report Period From': fromDate,
            'Report Period To': toDate,
            'Total Brands': userIdsToProcess.length,
            'Total Orders': grandTotalOrders,
            'Total Items': grandTotalItems,
            'Total Items Amount': grandTotalItemsAmount.toFixed(2),
            'Total Shipping Amount': grandTotalShippingAmount.toFixed(2),
            'Total Packaging Amount': grandTotalPackagingAmount.toFixed(2),
            'Total Branding Amount': grandTotalBrandingAmount.toFixed(2),
            'Grand Total': (grandTotalItemsAmount + grandTotalShippingAmount + grandTotalPackagingAmount + grandTotalBrandingAmount).toFixed(2),
            'Generation Date': new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
        }];

        // Generate and download Excel report
        await generateComprehensiveExcelReport(summaryData, fromDate, toDate);
        
        alert('Summary report downloaded successfully!');
        
    } catch (error) {
        console.error("Error generating summary report:", error);
        alert("Failed to generate summary report. Please try again.");
    } finally {
        setGenerating(false);
    }
};

// Helper function to generate comprehensive Excel report
const generateComprehensiveExcelReport = async (data, fromDate, toDate) => {
    const XLSX = window.XLSX || require('xlsx');
    
    const workbook = XLSX.utils.book_new();
    
    // 1. Overall Summary Sheet
    const overallSheet = XLSX.utils.json_to_sheet(data.overallSummary);
    XLSX.utils.book_append_sheet(workbook, overallSheet, 'Overall Summary');
    
    // 2. All Products Details Sheet
    if (data.allProducts.length > 0) {
        const productsSheet = XLSX.utils.json_to_sheet(data.allProducts);
        XLSX.utils.book_append_sheet(workbook, productsSheet, 'All Products');
    }
    
    // 3. All Shipping Details Sheet
    if (data.allShipping.length > 0) {
        const shippingSheet = XLSX.utils.json_to_sheet(data.allShipping);
        XLSX.utils.book_append_sheet(workbook, shippingSheet, 'All Shipping');
    }
    
    // 4. All Packaging Details Sheet
    if (data.allPackaging.length > 0) {
        const packagingSheet = XLSX.utils.json_to_sheet(data.allPackaging);
        XLSX.utils.book_append_sheet(workbook, packagingSheet, 'All Packaging');
    }

    if (data.allBranding.length > 0) {
    const brandingSheet = XLSX.utils.json_to_sheet(data.allBranding);
    XLSX.utils.book_append_sheet(workbook, brandingSheet, 'All Branding');
}
    
    // 5. Brand-wise Totals Sheet
    const brandTotalsSheet = XLSX.utils.json_to_sheet(data.brandWiseTotals);
    XLSX.utils.book_append_sheet(workbook, brandTotalsSheet, 'Brand Wise Totals');
    
    // 6. Order Details Sheet
    const orderDetailsSheet = XLSX.utils.json_to_sheet(data.orderDetails);
    XLSX.utils.book_append_sheet(workbook, orderDetailsSheet, 'Order Details');
    
    // 7. Tax Breakdown Sheet
    const taxBreakdownSheet = XLSX.utils.json_to_sheet(data.taxBreakdown);
    XLSX.utils.book_append_sheet(workbook, taxBreakdownSheet, 'Tax Breakdown');
    
    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    // Download the file
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Comprehensive_Invoice_Report_${fromDate}_to_${toDate}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
};



const generateExcelReport = async (data, brandName, fromDate, toDate) => {
    // Using SheetJS/xlsx library
    const XLSX = window.XLSX || require('xlsx');
    
    const workbook = XLSX.utils.book_new();
        
    // Summary Sheet
    const summarySheet = XLSX.utils.json_to_sheet(data.summary);
    XLSX.utils.book_append_sheet(workbook, summarySheet, 'Summary');
    
    // Invoice Details Sheet
    const invoiceSheet = XLSX.utils.json_to_sheet(data.invoiceDetails);
    XLSX.utils.book_append_sheet(workbook, invoiceSheet, 'Invoice Details');
    
    // Order Details Sheet
    const orderSheet = XLSX.utils.json_to_sheet(data.orderDetails);
    XLSX.utils.book_append_sheet(workbook, orderSheet, 'Order Details');
    
    // Generate Excel file as blob (no download popup)
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    return blob;
};


const uploadExcelToStorage = async (excelBlob, brandName, fromDate, toDate) => {
    try {
        const fileName = `${brandName}_Invoice_Report_${fromDate}_to_${toDate}_${Date.now()}.xlsx`;
        const storageRef = ref(Storage, `excel-reports/${fileName}`);
        
        // Upload the Excel blob to Firebase Storage
        const snapshot = await uploadBytes(storageRef, excelBlob);
        
        // Get the download URL
        const downloadURL = await getDownloadURL(snapshot.ref);
        
        return downloadURL;
        
    } catch (error) {
        console.error('Error uploading Excel file to Firebase:', error);
        throw error;
    }
};
    



return (
    <div className="brand-monthly-invoice-page">
        <div className="invoice-container">
            <div className="main-content">
                <h1>Monthly Invoice Generator</h1>

                <div className="filter-section">
                    <div className="filter-item">
                        <label htmlFor="brand-select">Select Brand: </label>
                        <select id="brand-select" value={selectedBrand} onChange={(e) => setSelectedBrand(e.target.value)}>
                            {brands.map((brand, index) => (
                                <option key={index} value={brand}>{brand}</option>
                            ))}
                        </select>
                    </div>
                    <div className="filter-item">
                        <label htmlFor="from-date">From Date: </label>
                        <input type="date" id="from-date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    </div>
                    <div className="filter-item">
                        <label htmlFor="to-date">To Date: </label>
                        <input type="date" id="to-date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </div>

                    {/* NEW: Load Data Button */}
                    <button
                        onClick={fetchInvoices}
                        disabled={loadingData || !fromDate || !toDate}
                        className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                    >
                        {loadingData ? 'Loading...' : 'Load Data'}
                    </button>
                </div>
{(loadingData || generating) && (
    <div style={{
        margin: '20px 0',
        padding: '16px',
        background: '#f0f4ff',
        borderRadius: '8px',
        border: '1px solid #c7d7f9'
    }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
            <span style={{ fontSize: '14px', color: '#333' }}>{progressLabel}</span>
            <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#3b5bdb' }}>{progress}%</span>
        </div>
        <div style={{
            width: '100%',
            height: '10px',
            background: '#dde3f5',
            borderRadius: '999px',
            overflow: 'hidden'
        }}>
            <div style={{
                width: `${progress}%`,
                height: '100%',
                background: 'linear-gradient(90deg, #3b5bdb, #748ffc)',
                borderRadius: '999px',
                transition: 'width 0.3s ease'
            }} />
        </div>
    </div>
)}

                {/* Only show rest of UI after data is loaded */}
              {dataLoaded && !loadingData && (
                    <>
                        <button
                            onClick={downloadSummaryReport}
                            disabled={generating}
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:opacity-50"
                        >
                            {generating ? 'Generating...' : 'Download Summary Report'}
                        </button>

                        <div className="action-section">
                            <button
                                onClick={generateMonthlyInvoices}
                                className="generate-invoice-btn"
                                disabled={generating || !fromDate || !toDate}
                            >
                                {generating ? 'Generating...' : 'Generate Monthly Invoice'}
                            </button>
                        </div>

                        <div className="invoice-summary">
                            <div className="summary-item"><strong>Total Orders:</strong> {filteredInvoices.length}</div>
                            <div className="summary-item"><strong>Total Items:</strong> {totalQuantity}</div>
                            <div className="summary-item"><strong>Total Items Amount:</strong> ₹{totalItemsPrice.toFixed(2)}</div>
                            <div className="summary-item"><strong>Total Shipping:</strong> ₹{totalShippingPrice.toFixed(2)}</div>
                            <div className="summary-item"><strong>Total Packaging:</strong> ₹{totalPackagingPrice.toFixed(2)}</div>
                            <div className="summary-item"><strong>Total Branding:</strong> ₹{totalBrandingPrice.toFixed(2)}</div>
                            <div className="summary-item total-price">
                                <strong>Grand Total:</strong> ₹{(totalItemsPrice + totalShippingPrice + totalPackagingPrice + totalBrandingPrice).toFixed(2)}
                            </div>
                        </div>

                        <h2>Orders Included in Monthly Invoice</h2>
                        <table className="invoice-orders-table">
                            <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Order Date</th>
                                    <th>Items Quantity</th>
                                    <th>Items Amount</th>
                                    <th>Shipping Amount</th>
                                    <th>Packaging Amount</th>
                                    <th>Branding Amount</th>
                                    <th>Total Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredInvoices.map((invoice) => (
                                    <tr key={invoice.id}>
                                        <td>{invoice.id}</td>
                                        <td>{invoice.orderDate}</td>
                                        <td>{invoice.totalQuantity}</td>
                                        <td>₹{invoice.totalItemsPrice.toFixed(2)}</td>
                                        <td>₹{(invoice.totalShippingCharges || 0).toFixed(2)}</td>
                                        <td>₹{(invoice.totalPackagingCharges || 0).toFixed(2)}</td>
                                        <td>₹{(invoice.totalBrandingCharges || 0).toFixed(2)}</td>
                                        <td>₹{(invoice.totalItemsPrice + (invoice.totalShippingCharges || 0) + (invoice.totalPackagingCharges || 0) + (invoice.totalBrandingCharges || 0)).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {filteredInvoices.length === 0 && (
                            <p className="no-data">No invoices found for the selected criteria.</p>
                        )}
                    </>
                )}
            </div>
        </div>
    </div>
);

};

export default BrandMonthlyInvoice;